module.exports = __webpack_public_path__ + "static/img/bg21.3754c73.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg21.png
// module id = 9/zx
// module chunks = 1